import appCONST from 'constants/app.constants';

export default function IeCors($window) {
    'ngInject';

    const isIE9 = detectIE9();

    /**
     * Detect the IE9 browser by checking user agent
     */
    function detectIE9() {
        return $window.navigator.userAgent.indexOf('MSIE 9.') !== -1;
    }

    /**
     * Apply trick to enable CORS in IE9 browser
     * IE9 doesn't support CORS with XMLHTTPRequest (http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx)
     * So we should use alternative way to enable this.
     * XDomain (https://github.com/jpillora/xdomain) was used for such alternative.
     */
    function initXDomain() {
        const slaveObject = {};

        slaveObject[appCONST.serverUrl] = appCONST.ieCORS;
        xdomain.slaves(slaveObject);
    }

    /**
     * Setup XDomain only for IE9, other browsers will work without this library
     */
    if (isIE9) {
        initXDomain();
    }

}



// WEBPACK FOOTER //
// ./src/app/configs/ieCORS.js